import React, { useState } from "react";
import { useAppSelector } from "../../../../redux/store";
import Message from "../../../components/message";
import { MessageSections } from "../../../components/message/message";
import { StandardDialogFooter } from "../../../components/dialogs/standard-dialog/standard-dialog";
import { DialogContent } from "@mui/material";
import BarekamInput from "../../../components/input";
import BankCards from "../bank-cards/bank-cards";
import { BindingModel } from "../../../../redux/reducers/balance-reducers";
import paymentService from "../../../../services/payment-service";
import { DialogContentContainer } from "./styled";
import { getMessage } from "../../../shared/helper-functions";

const TopUpDialog = ({ bindings, handleSubmit, handleCancel, balanceLeft }: TopUpDialogProps) => {
    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    const { matchesPhone } = useAppSelector(state => state.deviceReducer);

    const [amount, setAmount] = useState<number | null>(balanceLeft || null);
    const [amountError, setAmountError] = useState<string>();
    const [selectedCardIndex, setSelectedCardIndex] = useState<number | null>(0);

    async function handleAddNewPaymentMethod() {
        if (amount) {
            handleCancel();
            // Open window immediately to avoid Safari popup blocker
            const paymentWindow = window.open('', '_blank');
            
            await paymentService.topUpBalanceWithoutBinding(true, amount)
                .then(payload => {
                    if (payload && payload.data && payload.data.paymentUrl) {
                        if (paymentWindow) {
                            paymentWindow.location.href = payload.data.paymentUrl;
                        }
                    } else {
                        // Close the blank window if payment URL is not available
                        if (paymentWindow) {
                            paymentWindow.close();
                        }
                    }
                })
                .catch(error => {
                    // Close the blank window on error
                    if (paymentWindow) {
                        paymentWindow.close();
                    }
                });
        } else {
            setAmountError('missing_amount');
        }
    }

    function submitPayment() {
        if (!amount) {
            setAmountError('missing_amount');
        }

        if (selectedCardIndex === null) {
            setAmountError('missing_payment_method');
        }

        handleSubmit(selectedCardIndex, amount);
    }

    function onCardSelect(index: number | null) {
        setSelectedCardIndex(index);
    }

    return (
        <>
            <DialogContent>
                <DialogContentContainer>
                    <BarekamInput value={amount || ''}
                        placeholder={getMessage('amount_amd', MessageSections.MAIN, messageCache, languageId)}
                        label={getMessage('amount_amd', MessageSections.MAIN, messageCache, languageId)}
                        type={"number"}
                        customInputVariant={"standard"}
                        width={matchesPhone ? '100%' : '30%'}
                        onChange={(event) => setAmount(+event.target.value)}
                        error={!!amountError}
                        errorMessage={amountError && getMessage(amountError, MessageSections.MAIN, messageCache, languageId)}
                        required />
                    <BankCards removable={false}
                        bindings={bindings}
                        selectedCardIndex={selectedCardIndex}
                        addNewPaymentMethod={true}
                        onAddNewPaymentMethod={handleAddNewPaymentMethod}
                        onCardSelect={(index) => onCardSelect(index)} />
                </DialogContentContainer>
            </DialogContent>
            <StandardDialogFooter
                saveLabel={<Message messageKey={'submit'} sectionId={MessageSections.MAIN} />}
                onSave={submitPayment}
                onCancel={() => handleCancel()} />
        </>
    )
}

interface TopUpDialogProps {
    bindings: BindingModel[],
    handleSubmit: (cardIndex: number | null, amount: number | null) => void,
    handleCancel: () => void,
    balanceLeft?: number;
}

export default TopUpDialog;
